export function websocketUrlFor(locationLike) {
  if (!locationLike) return "ws://127.0.0.1:8787/ws";

  const { hostname, host, port, protocol } = locationLike;
  const localParcel =
    port === "1234" && (hostname === "127.0.0.1" || hostname === "localhost");
  if (localParcel) return "ws://127.0.0.1:8787/ws";

  const wsProtocol = protocol === "https:" ? "wss:" : "ws:";
  return `${wsProtocol}//${host}/ws`;
}

export function httpUrlFor(locationLike) {
  if (!locationLike) return "http://127.0.0.1:8787";

  const { hostname, host, port, protocol } = locationLike;
  const localParcel =
    port === "1234" && (hostname === "127.0.0.1" || hostname === "localhost");
  if (localParcel) return "http://127.0.0.1:8787";

  return `${protocol}//${host}`;
}

// Production uses the same host as the page, through nginx. Parcel's local
// development port remains wired to the Go server on 8787.
export const WS_URL = websocketUrlFor(
  typeof window === "undefined" ? null : window.location,
);

// The Past Games API follows the same local-development / same-origin split.
export const HTTP_URL = httpUrlFor(
  typeof window === "undefined" ? null : window.location,
);
